<template>
    <div v-bind="$attrs" @click="open" class="cursor-pointer">
        <slot></slot>
    </div>
    <Teleport to="body">
        <div
            v-if="isOpen"
            class="
                bg-black bg-opacity-25
                fixed
                top-0
                left-0
                w-full
                h-full
                z-[1000]
                flex
                items-center
                justify-center
            "
            @click.self="closeViaBackdrop"
        >
            <div
                class="
                    bg-white
                    rounded-lg
                    shadow-lg
                    p-4
                    relative
                    font-sans
                    min-w-[30vw]
                "
            >
                <header class="flex items-center mb-4">
                    <h3 class="mr-12 font-semibold text-lg" v-if="title">
                        {{ title }}
                    </h3>
                    <button
                        type="button"
                        class="
                            rounded-md
                            ml-auto
                            leading-[0]
                            p-1
                            hover:bg-gray-100
                            text-gray-500 text-2xl
                            z-[100]
                        "
                        @click="isOpen = false"
                    >
                        <ion-icon name="close"></ion-icon>
                    </button>
                </header>
                <div></div>
                <slot
                    name="body"
                    v-bind="{
                        close: close,
                    }"
                ></slot>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: "Modal",
    props: {
        title: {
            type: String,
            required: false,
        },
        canCloseViaBackdrop: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        open() {
            this.isOpen = true;
            this.$emit("open");
        },
        close() {
            this.isOpen = false;
        },
        closeViaBackdrop() {
            if (this.canCloseViaBackdrop) {
                this.close();
            }
        },
    },
};
</script>

<style scoped></style>
